import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#000000', // A
          'primary-darken1': '#000000', // R
          'primary-lighten1': '#EDEDED', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#00516D', // B
          'secondary-darken1': '#001E29', // D
          secondaryBtnText: '#FFFFFF', // B'
          headerBack: '#CD1B2F', // E
          headerText: '#FFFFFF', // F
          logoutBtnText: '#FFFFFF', // G
          topSchoolNamePc: '#000000', // H
          topSecondaryBtn: '#000000', // I
          topSecondaryBtnText: '#FFFFFF', // J
          topPrimaryBtn: '#CD1B2F', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#00516D', // N
          secondaryOutLineBtnText: '#00516D', // O
          topBtnUpTextSp: '#00516D', // P
          topBtnBackSp: '#FFFFFF', // Q'
          eventHeaderBack: '#00516D',
          eventHeaderText: '#FFFFFF',
          eventTopBorderSub: '#000000',
          accent: '#CD1B2F', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
